import script from "./ReportingView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportingView.vue?vue&type=script&setup=true&lang=js"

import "./ReportingView.vue?vue&type=style&index=0&id=6b03586b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b03586b"]])

export default __exports__